import { BaseComponent } from 'project/general';

class TestimonialSliderComponent extends BaseComponent {

    static getNamespace() {
        return 'testimonial-slider';
    }

    onInit() {
        var owlTestimonial = $(this.element);
        var owlID = owlTestimonial.attr("id");
        if ($(window).width() > 768) { // only for mobile devices
            $(owlTestimonial).find('.item').each(function (index) {
                if (index % 2 == 0) { // wrap by 2 items
                    $(this).add($(this).next('.item')).wrapAll('<div class="item__col" />');
                }
            });
        }
        
        owlTestimonial.owlCarousel({
            margin: 10,
            nav: false,
            dots: false,
            autoHeight: true,
            smartSpeed: 1000,
            items: 1,
            onInitialized: function (event) {
                $(owlTestimonial).find('.owl-item').attr('aria-selected', 'false');
                $(owlTestimonial).find('.owl-item.active').attr('aria-selected', 'true'); // let screen readers know an item is active

                // apply meta info to next and previous buttons and make them focusable
                $(owlTestimonial).parent().find('.owl-buttons__button--owl-next').attr('role', 'button').attr('title', 'Previous');
                $(owlTestimonial).parent().find('.owl-buttons__button--owl-next').attr('title', 'Next');
                $(owlTestimonial).attr('tabindex', '0');
                $('.owl-buttons__button--owl-next, .owl-buttons__button--owl-prev').attr('tabindex', '0');

                // listen for keyboard input
                $(document).on('keydown', function (e) {

                    var $focusedElement = $(document.activeElement),
                        singleOwl = $(owlTestimonial).data('owlCarousel'),
                        type = e.which == 39 ? 'next' : null,
                        type = e.which == 37 ? 'prev' : type,
                        type = e.which == 13 ? 'enter' : type;


                    // if the carousel is focused, use left and right arrow keys to navigate
                    if ($focusedElement.attr('id') === "testimonial-slider") {
                        if (type == 'next') {
                            owlTestimonial.trigger('next.owl.carousel');
                        } else if (type == 'prev') {
                            owlTestimonial.trigger('prev.owl.carousel');
                        }

                        // if the prev and next buttons are focused, catch "Enter" and navigate in the right direction
                    } else if (type == 'enter') {
                        if ($focusedElement.attr('id') === owlID + '-next') {
                            owlTestimonial.trigger('next.owl.carousel');
                        } else if ($focusedElement.attr('id') === owlID + '-prev') {
                            owlTestimonial.trigger('prev.owl.carousel');
                        }
                    }
                });
            }
        });

        // Button actions for next & Prev
        $(owlTestimonial).parent().find('#' + owlID + '-next').click(function () {
            owlTestimonial.trigger('next.owl.carousel');
        });
        $(owlTestimonial).parent().find('#' + owlID + '-prev').click(function () {
            owlTestimonial.trigger('prev.owl.carousel');
        });
    }

}

export default TestimonialSliderComponent;
